import React, { useState } from 'react';
import { ProductConfrimPage } from '../../../Container';
import { useUser } from '../../../Context/User';
import './Style.css';
const Index = ({ image, text }) => {
    const [popup, setPopup] = useState(false);
    const { addItem, clearCart } = useUser();
    return (
        <>
            <div className="order_item">
                <ProductConfrimPage
                    state={popup}
                    setStateFalse={() => {
                        setPopup((prev) => !prev);
                    }}
                    setStateFalseWithClearCart={() => {
                        clearCart();
                        setPopup((prev) => !prev);
                    }}
                />
                <img
                    onClick={() => {
                        addItem();
                        setPopup((prev) => !prev);
                    }}
                    src={image}
                    alt="Order"
                    className="order_item_image"
                />
                <p
                    onClick={() => {
                        setPopup((prev) => !prev);
                    }}
                    className="order_item_name"
                >
                    {text}
                </p>
            </div>
        </>
    );
};

export default Index;
